// src/admin/components/DateRangePicker.jsx
import React from 'react';

const inputStyle = {
  padding: '6px 10px', borderRadius: '6px',
  border: '1px solid rgba(0,0,0,0.12)', background: '#fff',
  fontSize: '13px', fontFamily: "'DM Sans', sans-serif",
};

export default function DateRangePicker({ since, before, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <input type="date" value={since || ''} onChange={e => onChange({ since: e.target.value })} style={inputStyle} />
      <span style={{ color: '#6c6c6d', fontSize: '12px' }}>→</span>
      <input type="date" value={before || ''} onChange={e => onChange({ before: e.target.value })} style={inputStyle} />
    </div>
  );
}
